import _defineProperty from "/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genFocusStyle, resetComponent } from '../../style';
import { genComponentStyleHook, mergeToken } from '../../theme/internal';

var genBreadcrumbStyle = function genBreadcrumbStyle(token) {
  var _$concat2, _Object$assign;

  var componentCls = token.componentCls,
      iconCls = token.iconCls;
  return _defineProperty({}, componentCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    color: token.itemColor,
    fontSize: token.fontSize
  }, _defineProperty(_Object$assign, iconCls, {
    fontSize: token.iconFontSize
  }), _defineProperty(_Object$assign, "ol", {
    display: 'flex',
    flexWrap: 'wrap',
    margin: 0,
    padding: 0,
    listStyle: 'none'
  }), _defineProperty(_Object$assign, "a", Object.assign({
    color: token.linkColor,
    transition: "color ".concat(token.motionDurationMid),
    padding: "0 ".concat(token.paddingXXS, "px"),
    borderRadius: token.borderRadiusSM,
    height: token.lineHeight * token.fontSize,
    display: 'inline-block',
    marginInline: -token.marginXXS,
    '&:hover': {
      color: token.linkHoverColor,
      backgroundColor: token.colorBgTextHover
    }
  }, genFocusStyle(token))), _defineProperty(_Object$assign, "li:last-child", {
    color: token.lastItemColor
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-separator"), {
    marginInline: token.separatorMargin,
    color: token.separatorColor
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-link"), _defineProperty({}, "\n          > ".concat(iconCls, " + span,\n          > ").concat(iconCls, " + a\n        "), {
    marginInlineStart: token.marginXXS
  })), _defineProperty(_Object$assign, "".concat(componentCls, "-overlay-link"), (_$concat2 = {
    borderRadius: token.borderRadiusSM,
    height: token.lineHeight * token.fontSize,
    display: 'inline-block',
    padding: "0 ".concat(token.paddingXXS, "px"),
    marginInline: -token.marginXXS
  }, _defineProperty(_$concat2, "> ".concat(iconCls), {
    marginInlineStart: token.marginXXS,
    fontSize: token.fontSizeIcon
  }), _defineProperty(_$concat2, '&:hover', {
    color: token.linkHoverColor,
    backgroundColor: token.colorBgTextHover,
    a: {
      color: token.linkHoverColor
    }
  }), _defineProperty(_$concat2, "a", {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }), _$concat2)), _defineProperty(_Object$assign, "&".concat(token.componentCls, "-rtl"), {
    direction: 'rtl'
  }), _Object$assign)));
}; // ============================== Export ==============================


export default genComponentStyleHook('Breadcrumb', function (token) {
  var BreadcrumbToken = mergeToken(token, {});
  return [genBreadcrumbStyle(BreadcrumbToken)];
}, function (token) {
  return {
    itemColor: token.colorTextDescription,
    lastItemColor: token.colorText,
    iconFontSize: token.fontSize,
    linkColor: token.colorTextDescription,
    linkHoverColor: token.colorText,
    separatorColor: token.colorTextDescription,
    separatorMargin: token.marginXS
  };
});